import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { filter, tap } from "rxjs/operators";
import { Supplier } from "../../supplier/supplier";
import { ReferenceService } from "../reference.service";
import { NewReferenceRequest } from "./new-reference-request";
import { NewReferenceResponse } from "./new-reference-response";

@Component({
  styleUrls: ['./new-reference.component.css'],
  templateUrl: './new-reference.component.html'
})
export class NewReferenceComponent {
  public error = false;
  public loading = false;
  public invalidPrice = false;
  public invalidTitle = false;
  public invalidIsbn = false;
  public invalidSupplier = false;

  public result!: NewReferenceResponse;
  public newReferenceRequest = new NewReferenceRequest();

  public onSupplierSelected = (supplier: Supplier) => this.newReferenceRequest.supplierId = supplier.id;

  constructor(
    public activeModal: NgbActiveModal,
    private referenceService: ReferenceService,
    private router: Router
  ) { }

  private validate(): boolean {
    var valid = true;

    if (this.newReferenceRequest.isbn == undefined || this.newReferenceRequest.isbn == "") {
      valid = false;
      this.invalidIsbn = true;
    }

    if (this.newReferenceRequest.price == undefined || this.newReferenceRequest.price == 0) {
      valid = false;
      this.invalidPrice = true;
    }

    if (this.newReferenceRequest.title == undefined || this.newReferenceRequest.title == "") {
      valid = false;
      this.invalidTitle = true;
    }

    if (this.newReferenceRequest.supplierId == undefined) {
      valid = false;
      this.invalidSupplier = true;
    }

    return valid;
  }

  public saveReference() {
    this.invalidIsbn = false;
    this.invalidPrice = false;
    this.invalidTitle = false;
    this.invalidSupplier = false;

    if (!this.validate()) {
      return;
    }

    this.loading = true;
    this.error = false;

    this.referenceService.create({
      isbn: this.newReferenceRequest.isbn.trim(),
      price: this.newReferenceRequest.price * 100,
      supplierId: this.newReferenceRequest.supplierId,
      title: this.newReferenceRequest.title
    }, { imageMaxWidth: 35 })
      .pipe(
        tap(response => this.result = response),
        filter(response => response.reference != undefined)
      )
      .subscribe({
        next: response => {
          this.router.navigate(["/inventory/reference"], { queryParams: { query: response.reference.isbn } });
          this.loading = false;
          this.activeModal.close();
        },
        error: e => {
          this.error = true;
          this.loading = false;
        }
      });
  }
}